(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hospitalization-discharge-to', {
            parent: 'entity',
            url: '/hospitalization-discharge-to',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'HospitalizationDischargeTos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hospitalization-discharge-to/hospitalization-discharge-tos.html',
                    controller: 'HospitalizationDischargeToController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('hospitalization-discharge-to-detail', {
            parent: 'entity',
            url: '/hospitalization-discharge-to/{id}',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
                pageTitle: 'HospitalizationDischargeTo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hospitalization-discharge-to/hospitalization-discharge-to-detail.html',
                    controller: 'HospitalizationDischargeToDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'HospitalizationDischargeTo', function($stateParams, HospitalizationDischargeTo) {
                    return HospitalizationDischargeTo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'hospitalization-discharge-to',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('hospitalization-discharge-to-detail.edit', {
            parent: 'hospitalization-discharge-to-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-discharge-to/hospitalization-discharge-to-dialog.html',
                    controller: 'HospitalizationDischargeToDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HospitalizationDischargeTo', function(HospitalizationDischargeTo) {
                            return HospitalizationDischargeTo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hospitalization-discharge-to.new', {
            parent: 'hospitalization-discharge-to',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-discharge-to/hospitalization-discharge-to-dialog.html',
                    controller: 'HospitalizationDischargeToDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('hospitalization-discharge-to', null, { reload: 'hospitalization-discharge-to' });
                }, function() {
                    $state.go('hospitalization-discharge-to');
                });
            }]
        })
        .state('hospitalization-discharge-to.edit', {
            parent: 'hospitalization-discharge-to',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPERVISOR'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-discharge-to/hospitalization-discharge-to-dialog.html',
                    controller: 'HospitalizationDischargeToDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HospitalizationDischargeTo', function(HospitalizationDischargeTo) {
                            return HospitalizationDischargeTo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hospitalization-discharge-to', null, { reload: 'hospitalization-discharge-to' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hospitalization-discharge-to.delete', {
            parent: 'hospitalization-discharge-to',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SUPERVISOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-discharge-to/hospitalization-discharge-to-delete-dialog.html',
                    controller: 'HospitalizationDischargeToDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HospitalizationDischargeTo', function(HospitalizationDischargeTo) {
                            return HospitalizationDischargeTo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hospitalization-discharge-to', null, { reload: 'hospitalization-discharge-to' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
